/**
------------------------------------------------------------------------------
  Section: Announcement Bar
  Purpose: set announcement bar settings
------------------------------------------------------------------------------
*/

import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'

class AnnouncementBar extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    const swiper = new Swiper(this, {
      // Optional parameters
      modules: [Autoplay],
      centeredSlides: true,
      autoplay: {
        delay: 5000,
      },
    })

    // Handle banner clicks when URL is present using event delegation
    this.addEventListener('click', (e) => {
      const slide = e.target.closest('.swiper-slide[data-banner-url]')
      if (slide) {
        const url = slide.getAttribute('data-banner-url')
        const openInNewTab = slide.getAttribute('data-banner-new-tab') === 'true'
        if (url) {
          if (openInNewTab) {
            window.open(url, '_blank', 'noopener,noreferrer')
          } else {
            window.location.href = url
          }
        }
      }
    })
  }
}
customElements.define('announcement-bar', AnnouncementBar)
